import { DataAttributeDefinitions } from 'scrivito'

import { pisaTimerecordClientDataClass } from './Pisa/pisaTimerecordClientDataClass'

const attributes: DataAttributeDefinitions = {}

export const TimerecordClient = pisaTimerecordClientDataClass(attributes)
